import { primaryOrSecondary } from "@syla/shared/helpers/primaryOrSecondary";

export function getUserDetails(props: {
  _id: string;
  name?: string;
  email: string;
}) {
  return primaryOrSecondary(props.name, props.email);
}
